import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  messageBlock: {
    background: 'white',
    borderColor: lightGrey
  }
})

export default useStyles
